import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '../../components/Modal'

export interface CloneOptions {
  keepAssetImages: boolean
  keepAssetImagePrompts: boolean
  keepShotPrompts: boolean
}

interface Props {
  open: boolean
  sourceName: string
  sourceWorkflow?: 'legacy' | 'casting_styling'
  onClose: () => void
  onConfirm: (opts: CloneOptions) => void
}

export default function CloneOptionsModal({ open, sourceName, sourceWorkflow, onClose, onConfirm }: Props) {
  const { t } = useTranslation('common')
  const [keepImages, setKeepImages] = useState(true)
  const [keepPrompts, setKeepPrompts] = useState(false)
  const [keepShotPrompts, setKeepShotPrompts] = useState(false)

  const handleConfirm = () => {
    onConfirm({ keepAssetImages: keepImages, keepAssetImagePrompts: keepPrompts, keepShotPrompts })
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('cloneOptions.title', { name: sourceName })}
      width="480px"
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={onClose}>{t('cancel')}</button>
          <button type="button" className="btn btn-primary" onClick={handleConfirm}>{t('nextStep')}</button>
        </>
      }
    >
      <p style={{ marginBottom: '0.75rem', color: 'var(--text-2)', fontSize: '0.9rem', lineHeight: 1.6 }}>
        {t('cloneOptions.description')}
      </p>

      {sourceWorkflow === 'legacy' && (
        <div
          style={{
            marginBottom: '0.75rem',
            padding: '0.65rem 0.75rem',
            border: '1px solid #f0d28a',
            borderRadius: '6px',
            background: '#fff8e6',
            color: '#7a4b00',
            fontSize: '0.86rem',
            lineHeight: 1.5,
          }}
        >
          {t('cloneOptions.legacyWorkflowWarning')}
        </div>
      )}

      <label style={{ display: 'flex', alignItems: 'center', margin: '0.5rem 0', cursor: 'pointer', color: 'var(--text)' }}>
        <input
          type="checkbox"
          checked={keepImages}
          onChange={(e) => setKeepImages(e.target.checked)}
        />
        <span style={{ marginLeft: '0.5rem' }}>{t('cloneOptions.keepAssetImages')}</span>
      </label>

      <label
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          margin: '0.5rem 0',
          paddingLeft: '1.5rem',
          cursor: keepImages ? 'not-allowed' : 'pointer',
          color: keepImages ? 'var(--text-3)' : 'var(--text)',
        }}
      >
        <input
          type="checkbox"
          checked={keepPrompts}
          disabled={keepImages}
          onChange={(e) => setKeepPrompts(e.target.checked)}
          style={{ marginTop: '0.25rem' }}
        />
        <span style={{ marginLeft: '0.5rem' }}>
          {t('cloneOptions.keepImagePrompts')}
          <span style={{ color: 'var(--text-3)', marginLeft: '0.5rem', fontSize: '0.8rem' }}>
            {keepImages ? t('cloneOptions.keepImagesHint') : t('cloneOptions.clearImagesHint')}
          </span>
        </span>
      </label>

      <label style={{ display: 'flex', alignItems: 'center', margin: '0.5rem 0', cursor: 'pointer', color: 'var(--text)' }}>
        <input
          type="checkbox"
          checked={keepShotPrompts}
          onChange={(e) => setKeepShotPrompts(e.target.checked)}
        />
        <span style={{ marginLeft: '0.5rem' }}>{t('cloneOptions.keepShotPrompts')}</span>
      </label>
    </Modal>
  )
}
